<app-availability-contact-sales *ngIf="step === 'contact-sales'"(selected)="onComplete()"></app-availability-contact-sales>
<div *ngIf="initialized && model">
    <app-select-availability
        *ngIf="step === 'select'"
        [selectedAvailability]="model.availability"
        [availabilityLevels]="model.availabilityLevels"
        (premiumSelected)="onPremiumSelected()"
        (standardSelected)="onStandardSelected()"
        (back)="onAvailabilityBack()"
    ></app-select-availability>
    <app-warning-confirm-box
        *ngIf="step === 'downgrade'"
        [hideCancelBtn]="true"
        [confirmHeadline]="'availability_downgrade_premium_confirm_headline' | i18next"
        [confirmDetailsHeadline]="'availability_downgrade_premium_confirm_headline' | i18next"
        [confirmDetailsText]="'availability_downgrade_premium_confirm_text' | i18next"
        [confirmBtn]="'availability_downgrade_premium_confirm_btn' | i18next"
        [footerCancelBtnText]="'availability_downgrade_premium_confirm_btn_cancel' | i18next"
        (back)="onDowngradeBack()"
        (confirm)="onDowngradeSelected()"
    ></app-warning-confirm-box>
    <app-invoice-address
        *ngIf="step === 'address'" 
        (next)="onInvoiceNext($event)" 
        (backEvent)="onInvoiceAddressBack()"
        [historyBack]="false"
    ></app-invoice-address>
    <app-payment-method *ngIf="step === 'payment'"
        (next)="onPaymentMethod($event)" 
        (backEvent)="onPaymentMethodBack()" 
        [onlyEmit]="true"
        [historyBack]="false" 
        [paymentMethod]="paymentMethod">
    </app-payment-method>
    <app-checkout-one-summary
        *ngIf="step === 'checkout'"
        [subscription]="model.subscription" 
        (back)="onSummaryBack()" 
        [historyBack]="false"
        (buy)="onBuy()"
    ></app-checkout-one-summary>

    <app-endcustomer-upgrade-order-complete
        *ngIf="step === 'complete'"
        (next)="onComplete()"
    ></app-endcustomer-upgrade-order-complete>
</div>